// PROMPT #308: raw Firebase Auth SDK errors (e.g. "Firebase: Error
// (auth/invalid-credential)") must never reach a rendered UI string. Maps
// known Firebase Auth error codes to a friendly, branded message; any
// unmapped code (or an error with no .code at all) falls back to a
// generic message — never to error.message/error.code/error.toString().
const FRIENDLY_AUTH_ERROR_MESSAGES = {
  'auth/invalid-credential': 'Incorrect email or password. Please try again.',
  'auth/user-not-found': 'Incorrect email or password. Please try again.',
  'auth/wrong-password': 'Incorrect email or password. Please try again.',
  'auth/too-many-requests': 'Too many attempts. Please try again later.',
  'auth/user-disabled': 'This account has been disabled. Contact support for help.',
  'auth/invalid-email': "That email address doesn't look right. Please check and try again.",
  'auth/network-request-failed': 'Network error. Please check your connection and try again.',
  // PROMPT #327: MFA challenge-completion codes (auth/multi-factor-auth-required
  // itself is intercepted before ever reaching this map — see LoginPage.js).
  'auth/invalid-verification-code': 'That code is incorrect. Please check and try again.',
  'auth/code-expired': 'That code has expired. Request a new one and try again.',
  'auth/captcha-check-failed': 'Verification failed. Please try again.',
  'auth/missing-verification-code': 'Please enter the verification code.',
  // PROMPT #328: confirmed via direct read of the installed @firebase/auth
  // SDK source (not guessed) — "The phone verification request contains an
  // invalid application verifier." This is the code the SDK's own
  // handleRecaptchaFlow() checks for in its reCAPTCHA-Enterprise-to-v2
  // fallback path, and a real candidate for what a site-key/domain-bound
  // reCAPTCHA token rejection surfaces as. Previously unmapped — a real gap
  // in Prompt #327's own table, not just a defensive addition.
  'auth/invalid-app-credential': 'Verification failed — this device or browser could not be confirmed. Please try again or contact support.',
  // PROMPT #329 (HC-SECURITY-007): MFA *enrollment*-specific codes —
  // distinct from the sign-in-time challenge codes above. multiFactor(user)
  // .enroll() requires a recent sign-in per the SDK's own docs, so
  // requires-recent-login is a realistic, not just defensive, case for a
  // long-lived super-admin session hitting Security for the first time.
  'auth/requires-recent-login': 'For your security, please sign out and sign back in, then try again.',
  'auth/second-factor-already-in-use': 'This phone number is already enrolled as a second factor.',
  'auth/maximum-second-factor-count-exceeded': 'The maximum number of second factors has already been enrolled on this account.',
  'auth/invalid-phone-number': "That phone number doesn't look right. Please enter it in international format (e.g. +15551234567).",
  'auth/missing-phone-number': 'Please enter a phone number.',
};

const GENERIC_AUTH_ERROR_MESSAGE = 'Something went wrong. Please try again.';

export function getFriendlyAuthErrorMessage(error) {
  const code = error && error.code;
  if (code && FRIENDLY_AUTH_ERROR_MESSAGES[code]) {
    return FRIENDLY_AUTH_ERROR_MESSAGES[code];
  }
  return GENERIC_AUTH_ERROR_MESSAGE;
}
